// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */ // MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS: sprocket-compat?this!
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
// Generic wrapper for internal event tracking.
//
// Use this for internal tracking code rather than
// creating a new endpoint in Rails unless you have
// a good reason.
// modern-bundle! import jQuery from 'jquery'
// modern-bundle! import routes from '../routes.js'
// modern-bundle! const c = {}
// modern-bundle! const $r = routes
// need to test this in sprockets too
if (!c.Server) {
  c.Server = {};
}
class Notification {
  notify(extra_params) {
    if (extra_params == null) {
      extra_params = {};
    }
    return jQuery.ajax({
      url: $r.api_v0_active_support_notifications_path({
        subdomain_param: "api"
      }),
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      data: jQuery.extend(extra_params, {
        name: this.name
      }),
      type: "POST",
      statusCode: {
        401: () => {
          if (this.options._second_try) {
            return;
          }
          return new c.Server.Notification(this.name, jQuery.extend(this.options, {
            _second_try: true
          })).notify(extra_params);
        }
      }
    });
  }
  constructor(name, options) {
    this.name = name;
    if (options == null) {
      options = {};
    }
    this.options = options;
  }
}
c.Server.Notification = Notification; // modern-bundle! export default Notification
window.Notification = Notification;